import { Grid } from "@mui/material";
import "react-dropzone-uploader/dist/styles.css";
import {
  getParams,
  navigate,
  sendGetRequest,
  sendPostRequest,
  sendPatchRequest,
  allowedOperations,
} from "../utils/utils";
import EditPage from "./component/edit-page";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";
import EasyTextEdit from "./component/text-edit";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";

const _ref = {
  uuid: "",
  storeRef: "",
  description: "",
  duration: null,
  playstore: true,
};

const PackageEdit = () => {
  const { uuid } = getParams();
  var [pakeji, setPakeji] = useState(_ref);
  const { canCreate } = allowedOperations();

  const [status, setStatus] = useState({
    error: false,
    loading: false,
    message: null,
  });
  useEffect(() => {
    sendGetRequest(
      `packages?uuid=${uuid}`,
      (loading) => setStatus({ ...{ loading: loading } }),
      (data) => setPakeji({ ...data })
    );
    return () => setPakeji(_ref);
    // eslint-disable-next-line
  }, [uuid]);

  const createUpdate = () => {
    if (!uuid) {
      delete pakeji.uuid;
      sendPostRequest(
        "packages",
        { ...pakeji },
        (loading) => setStatus({ ...{ loading: loading } }),
        (data) => {
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        }
      );
    } else {
      pakeji.uuid = uuid;
      sendPatchRequest(
        `packages/${uuid}`,
        pakeji,
        (loading) => setStatus({ ...{ loading: loading } }),
        (data) => {
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        }
      );
    }
  };

  const onValueChange = (value, tag) => setPakeji({ ...pakeji, [tag]: value });

  return (
    <EditPage
      title={uuid ? `Edit Package` : "Add Package"}
      status={status}
      btnLabel={canCreate ? (uuid ? "Update Now" : "Add Now") : null}
      onSave={() => createUpdate()}
      validated={
        pakeji.storeRef &&
        pakeji.description &&
        pakeji.playstore !== null &&
        pakeji.duration &&
        !status.loading
      }
      onBack={() =>
        navigate(`${AppRoutes.payments}/${AppRoutes.packages}`, true)
      }
      onFinish={() => {
        setStatus({ ...{ loading: false, message: null, error: false } });
        if (!status.error) {
          setPakeji({ ..._ref });
          navigate(`${AppRoutes.payments}/${AppRoutes.packages}`, true);
        }
      }}
    >
      <Grid item md={3} xs={12}>
        <EasyTextEdit
          label="Store Reference"
          placeholder="Store package reference code"
          type="text"
          id="storeRef"
          errorText=""
          textField={true}
          disabled={status.loading}
          value={pakeji.storeRef}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <EasyTextEdit
          placeholder="Package Description"
          label="Meaningful package description"
          type="text"
          id="description"
          textField={true}
          errorText=""
          disabled={status.loading}
          value={pakeji.description}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={3} xs={12}>
        <EasyTextEdit
          placeholder="Package Duration"
          label="Subscription duration in days"
          type="number"
          id="duration"
          textField={true}
          errorText=""
          disabled={status.loading}
          value={pakeji.duration}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={2} xs={12}>
        <FormControl sx={{ minWidth: 50 }} fullWidth>
          <InputLabel id="store">Store</InputLabel>
          <Select
            value={pakeji.playstore}
            label="Store"
            labelId="store"
            id="playstore"
            onChange={(e) => onValueChange(e.target.value, "playstore")}
          >
            {[
              { name: "PlayStore", value: true },
              { name: "AppleStore", value: false },
            ].map((souces) => {
              return (
                <MenuItem value={souces.value}>
                  &nbsp;&nbsp;&nbsp;{souces.name}
                  <br />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
    </EditPage>
  );
};

export default PackageEdit;
